import { render, staticRenderFns } from "./DonateEditForm.vue?vue&type=template&id=b337ed46&"
import script from "./DonateEditForm.vue?vue&type=script&lang=js&"
export * from "./DonateEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports